const viewOptions = document.querySelectorAll("svg.icon-eye-view");
const isDesktop = window.matchMedia("(min-width: 1024px)").matches;

/* // Agrega un evento de clic al body
document.body.addEventListener('click', function(event) {
  // Verifica si el clic ocurrió dentro de cualquier modal__inner
  if ( document.querySelector('.modal--is-active') ) {
    if (!isClickInsideModal(event)) {
        // Si el clic ocurrió fuera de cualquier modal__inner, ejecuta el código correspondiente
        document.querySelector('.modal--is-active').classList.remove('modal--is-active');
    }
  }
}); */

/**
 * Retrieves the color tooltip and input elements based on the provided option and parent elements.
 * @param {HTMLElement} option - The option element.
 * @param {HTMLElement} parent - The parent element.
 * @returns {Object} - An object containing the color tooltip and input elements.
 */

function getColorTooltipAndInput(option, parent) {
  const isMobileDOM = option.classList.contains("small");
  let colorTooltip;
  let input;
  if (isMobileDOM) {
    colorTooltip = parent.previousElementSibling;
    input = colorTooltip.previousElementSibling;
  } else {
    colorTooltip = parent.nextElementSibling;
    input = parent.previousElementSibling;
  
  }
  
  return { colorTooltip, input };
}

/**
 * Removes the specified element from the DOM and removes event listeners for scroll and click.
 * @param {Element} element - The element to be removed.
 */
function removeModal(element) {
  element.remove();

  document.removeEventListener("scroll", removeModal);
  document.removeEventListener("click", removeModal);
}

/**
 * Creates a color modal and appends it to the variants container.
 * The color modal is removed when the user scrolls or clicks outside of it.
 *
 * @param {HTMLElement} colorTooltip - The color tooltip element.
 * @param {HTMLElement} input - The input element.
 */
function createSmallModal(colorTooltip, input, event) {
  const existingModal = document.querySelector("div.variant-small-modal");

  if (existingModal) {
    existingModal.remove();
  }

  const div = document.createElement("div");
  const variantsContainer = document.querySelector("main");
  const labelEl = event.target.closest('label.variant-option');
  const img = labelEl ? labelEl.querySelector('img.option-image') : null;

  div.classList.add("variant-small-modal");

  // Start building modal HTML
  let modalHTML = `
    <span class='btn-close'>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
        <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 
                 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 
                 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 
                 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 
                 342.6 150.6z"/>
      </svg>
    </span>`;

  // If image exists, add it to the modal
  if (img && img.dataset.title) {
    modalHTML += `<div class="modal-header">
                    <div class="h5">${img.dataset.title}</div>
                  </div>`;
  }
  if (img && img.tagName === 'IMG') {
    modalHTML += `<div class="modal-img-wrapper">
                    <img src="${img.src}" alt="Variant Image" class="modal-img" />
                  </div>`;
  }
  if (img && img.dataset.desc) {
    modalHTML += `<div class="modal-footer">
                    <small>${img.dataset.desc}<small>
                  </div>`;
  }

  // Add the color tooltip content
  if (colorTooltip) modalHTML += colorTooltip.innerHTML;

  div.innerHTML = modalHTML;
  variantsContainer.appendChild(div);

  const closeModalBtn = div.querySelector("span.btn-close");

  closeModalBtn.addEventListener("click", () => {
    removeModal(div);
  });

  document.addEventListener("scroll", () => {
    removeModal(div);
  });

  document.addEventListener("click", (event) => {
    const isOutsideModal =
      event.target !== input &&
      event.target !== div &&
      !div.contains(event.target);

    if (isOutsideModal) {
      removeModal(div);
    }
  });
}


/**
 * Renders a big modal and adds event listeners to close it.
 * @param {HTMLElement} variantModal - The variant modal element.
 */
function renderBigModal(variantModal) {
  variantModal.classList.toggle("modal--is-active");

  const closeModalBtn = variantModal.querySelector("button.modal__close");

  closeModalBtn.addEventListener("click", () => {
    variantModal.classList.remove("modal--is-active");
  });

  document.addEventListener("scroll", () => {
    variantModal.classList.remove("modal--is-active");
  });

  // Close the modal when the user clicks outside of it
  document.addEventListener("click", (event) => {
    const isOutsideModal =
      event.target !== input &&
      event.target !== div &&
      !div.contains(event.target);

    if (isOutsideModal) {
      removeModal(div);
    }
  });
}

/**
 * Returns the target modal element based on the given option.
 * @param {HTMLElement} option - The option element.
 * @returns {HTMLElement} - The target modal element.
*/

function getTargetModal(option) {
  const isMobileDOM = option.classList.contains("small");

  if (isMobileDOM) {
    return option.parentElement.nextElementSibling;
  } else {
    return option.parentElement.parentElement.previousElementSibling.previousElementSibling;
  }
}

viewOptions.forEach((option) => {
  const parent = option.parentElement.parentElement;
  const { colorTooltip, input } = getColorTooltipAndInput(option, parent);

  option.addEventListener("click", (event) => {
    event.stopPropagation();
  
    createSmallModal(colorTooltip, input, event);

    /* if (isDesktop) {
      const targetModal = getTargetModal(option);
      renderBigModal(targetModal);
    } else {
      createSmallModal(colorTooltip, input);
    } */
  });
});